// Based on:
// https://vue-i18n.intlify.dev/guide/#javascript

import PreferencesService from '../../services/PreferencesService'
import { createI18n } from 'vue-i18n'

// English
import {
  messages as enMessages,
  datetimeFormats as enDatetimeFormats,
  numberFormats as enNumberFormats,
} from './en'

// Spanish (Español)
import { messages as esMessages } from './es'

export default createI18n({
  legacy: false,
  locale: PreferencesService.preferences.locale ?? 'en',
  fallbackLocale: 'en',
  messages: {
    en: enMessages,
    es: esMessages,
  },
  datetimeFormats: {
    en: enDatetimeFormats,
  },
  numberFormats: {
    en: enNumberFormats,
  },
})
